<form [formGroup]="form" (ngSubmit)="export(model.mapType)">
    <formly-form [form]="form" [fields]="fields" [model]="model"></formly-form>
    <button pButton type="submit" icon="icon-cloud-download" [label]="(isExportingResults$ | async) ? 'Exporting' : 'Export'" [disabled]="exportDisabled() || (isExportingResults$ | async)"></button>
</form>
